import * as z from 'zod';

import { AttachmentSchema } from './common/attachment';

export const FixtureTypeSchema = z.enum(
  [
    'toilet',
    'urinal',
    'faucet_lavatory_public',
    'faucet_lavatory_residential',
    'faucet_kitchen',
    'faucet_kitchen_residential',
    'showerhead',
    'showerhead_residential',
    'pre_rinse_spray_valve',
    'clothes_washer_residential_compact_front_loading',
    'clothes_washer_residential_compact_top_loading',
    'clothes_washer_residential_standard_front_loading',
    'clothes_washer_residential_standard_top_loading',
    'dishwasher_residential_standard',
    'dishwasher_residential_compact',
    'clothes_washer_commercial_front_loading',
    'clothes_washer_commercial_top_loading',
    'dishwasher_commercial_low_temp_under_counter',
    'dishwasher_commercial_low_temp_stationary_single_tank_door',
    'dishwasher_commercial_low_temp_single_tank_conveyor',
    'dishwasher_commercial_low_temp_multi_tank_conveyor',
    'dishwasher_commercial_hi_temp_under_counter',
    'dishwasher_commercial_hi_temp_stationary_single_tank_door',
    'dishwasher_commercial_hi_temp_single_tank_conveyor',
    'dishwasher_commercial_hi_temp_multi_tank_conveyor',
    'dishwasher_commercial_hi_temp_pot_pan_and_utensil',
  ],
  { error: 'Fixture type is required' },
);
export type FixtureType = z.infer<typeof FixtureTypeSchema>;

export const UnitSchema = z.enum(['Gpf', 'Gpm', 'G/cycle', 'Lpf', 'Gph']);
export type Unit = z.infer<typeof UnitSchema>;

export const AuditWaterFixtureFormEntrySchema = z.object({
  section: z
    .string({ error: 'Section is required' })
    .nonempty({ error: 'Section is required' }),
  room: z
    .string({ error: 'Room is required' })
    .nonempty({ error: 'Room is required' }),
  fixtureType: FixtureTypeSchema,
  quantity: z.coerce.number().optional(),
  usageRate: z.coerce.number().optional(),
  unit: UnitSchema.optional(),
  comments: z.string().optional(),
  attachments: z.array(AttachmentSchema).optional(),
});
export type AuditWaterFixtureFormEntry = z.infer<
  typeof AuditWaterFixtureFormEntrySchema
>;

export const AuditWaterFixtureFormSchema = z.object({
  type: z.literal('water-fixture'),
  entries: z.array(AuditWaterFixtureFormEntrySchema),
});
export type AuditWaterFixtureForm = z.infer<typeof AuditWaterFixtureFormSchema>;
